/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { DataClass } from '../models/DataClass';

export class DataClassesFilters {
  /**
  * Matches if any value in this list is in the `dataClasses` list.
  */
  'containsAnyOf'?: Array<DataClass>;
  /**
  * Matches if none of the values in this list are in the `dataClasses` list.
  */
  'containsNoneOf'?: Array<DataClass>;
  /**
  * Matches if all values in this list are in the `dataClasses` list.
  */
  'containsAllOf'?: Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "containsAnyOf",
      "baseName": "containsAnyOf",
      "type": "Array<DataClass>",
      "format": ""
    },
    {
      "name": "containsNoneOf",
      "baseName": "containsNoneOf",
      "type": "Array<DataClass>",
      "format": ""
    },
    {
      "name": "containsAllOf",
      "baseName": "containsAllOf",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return DataClassesFilters.attributeTypeMap;
  }

  public constructor() {
  }
}

